import { useEffect, useState } from "react";
import {
  Card,
  Col,
  Flex,
  Image,
  Row,
  Space,
  Spin,
  Grid,
  Typography,
  Avatar,
} from "antd";
import {
  LoadingOutlined,
  MailOutlined,
  BulbOutlined,
  TeamOutlined,
  SafetyOutlined,
  CheckCircleOutlined,
  CustomerServiceOutlined,
} from "@ant-design/icons";

import aboutUsImage from "../../../Images/Common/aboutUs-image.svg";

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

const AboutUs = () => {
  const screens = useBreakpoint();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const ITEMS = [
    {
      icon: (
        <MailOutlined
          style={{
            color: "#002753",
          }}
        />
      ),
      title: "Quality",
      desc: "Reliable, durable furniture backed by strict quality control.",
    },
    {
      icon: (
        <BulbOutlined
          style={{
            color: "#002753",
          }}
        />
      ),
      title: "Innovation",
      desc: "New materials and ideas that improve design, efficiency, and sustainability.",
    },
    {
      icon: (
        <TeamOutlined
          style={{
            color: "#002753",
          }}
        />
      ),
      title: "Customer-First",
      desc: "We build lasting relationships by tailoring solutions to customer needs.",
    },
    {
      icon: (
        <SafetyOutlined
          style={{
            color: "#002753",
          }}
        />
      ),
      title: "Integrity",
      desc: "We uphold honesty and fulfill every promise we make.",
    },
    {
      icon: (
        <TeamOutlined
          style={{
            color: "#002753",
          }}
        />
      ),
      title: "Collaboration",
      desc: "Collaboration and mutual respect drive our shared success.",
    },
    {
      icon: (
        <CheckCircleOutlined
          style={{
            color: "#002753",
          }}
        />
      ),
      title: "Sustainability",
      desc: "Eco-friendly practices that reduce waste and environmental impact.",
    },
    {
      icon: (
        <CustomerServiceOutlined
          style={{
            color: "#002753",
          }}
        />
      ),
      title: "Service",
      desc: "Support that goes beyond delivery — we’re with you every step.",
    },
  ];

  return (
    <Space direction="vertical" className="page-container" size={0}>
      {isLoading && (
        <Spin
          spinning={isLoading}
          indicator={<LoadingOutlined spin />}
          fullscreen
        />
      )}

      <Row
        justify="center"
        style={{
          backgroundColor: "#F9FAFB",
          // backgroundColor: "red",
          // marginTop: -16,
          marginLeft: "-8vw",
          marginRight: "-8vw",
          paddingBottom: 60,
          paddingTop: screens.xs ? 30 : 80,
          paddingLeft: screens.xs ? 30 : "6vw",
          paddingRight: screens.xs ? 30 : "6vw",
        }}
      >
        <Col
          xl={{ flex: "50%" }}
          style={{
            paddingLeft: screens.xs ? 0 : 30,
          }}
        >
          <h2
            style={{
              fontSize: 36,
              fontWeight: 700,
              color: "#002753",
              marginTop: 0,
              marginBottom: 15,
            }}
          >
            About Teamstar
          </h2>

          <div
            style={{
              color: "#374151",
              fontSize: 16,
              width: "95%",
              textAlign: "justify",
              lineHeight: 1.5,
            }}
          >
            <p>
              Established in 2008, Teamstar specialises in furniture hardware,
              accessories, fancy ply, wave boards, and more. As a leader in
              wardrobe, furniture, and kitchen fittings, we source directly from
              trusted local and international manufactures. With extensive ready
              stock, we provide customers with seamless, hassle-free shopping
              convenience.
            </p>

            <p
              style={{
                marginTop: 16,
                marginBottom: 16,
              }}
            >
              Our stores feature comprehensive product displays and friendly
              sales staff who make it easy for customer to test, analyse, and
              purchase items with confidence. Currently operating in 27
              locations across Klang Valley and Perak, we aim to expand to 50
              stores nationwide within 5 years.
            </p>

            <p>
              Committed to innovation, we continually update our showrooms with
              the latest furniture accessories and fittings, ensuring quality,
              affordability, and customer satisfaction at every steps.
            </p>
          </div>

          <Flex
            wrap
            gap={16}
            style={{
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            <Card
              style={{
                border: 0,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                width: screens.xs ? 160 : 120,
              }}
            >
              <p
                style={{
                  color: "#002753",
                  fontSize: 30,
                  fontWeight: 700,
                }}
              >
                25+
              </p>

              <p
                style={{
                  color: "#4B5563",
                  fontSize: 16,
                }}
              >
                Stores
              </p>
            </Card>

            <Card
              style={{
                border: 0,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                width: screens.xs ? 160 : 120,
              }}
            >
              <p
                style={{
                  color: "#002753",
                  fontSize: 30,
                  fontWeight: 700,
                }}
              >
                10k+
              </p>

              <p
                style={{
                  color: "#4B5563",
                  fontSize: 16,
                }}
              >
                Products
              </p>
            </Card>

            <Card
              style={{
                border: 0,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <p
                style={{
                  color: "#002753",
                  fontSize: 30,
                  fontWeight: 700,
                }}
              >
                50k+
              </p>

              <p
                style={{
                  color: "#4B5563",
                  fontSize: 16,
                }}
              >
                Happy Customers
              </p>
            </Card>
          </Flex>
        </Col>

        <Col
          style={{
            paddingLeft: screens.xs ? 0 : 20,
            paddingTop: screens.xs ? 40 : 0,
            backgroundColor: "#F9FAFB",
          }}
        >
          <Image
            preview={false}
            src={aboutUsImage}
            alt="About Us"
            style={{
              width: "100%",
              height: screens.xs ? "auto" : 500,
              borderRadius: 8,
              boxShadow: screens.xs ? "none" : "0 2px 8px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#F9FAFB",
            }}
          />
        </Col>
      </Row>

      <Flex
        wrap
        gap={30}
        style={{
          marginTop: 60,
          marginBottom: 60,
          backgroundColor: "#ffffff",
        }}
        justify="center"
      >
        <Card
          style={{
            height: "auto",
            width: screens.xs ? "100%" : 500,
            borderLeft: "4px solid #FFD600",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          <h3
            style={{
              fontWeight: "600",
              color: "#002753",
              fontSize: 24,
              marginTop: 5,
              marginBottom: 10,
            }}
          >
            Our Vision
          </h3>

          <p
            style={{
              color: "#374151",
              fontSize: 16,
            }}
          >
            To become the most trusted name in furniture hardware across Asia,
            known for quality, creativity, and service that moves the industry
            forward.
          </p>
        </Card>

        <Card
          style={{
            height: "auto",
            width: screens.xs ? "100%" : 500,
            borderLeft: "4px solid #002753",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          <h3
            style={{
              fontWeight: "600",
              color: "#002753",
              fontSize: 24,
              marginTop: 5,
              marginBottom: 10,
            }}
          >
            Our Mission
          </h3>

          <p
            style={{
              color: "#374151",
              fontSize: 16,
            }}
          >
            Our mission is to empower furniture makers and designers with
            reliable, innovative, and stylish hardware solutions — helping them
            build spaces that combine beauty, function, and longevity.
          </p>
        </Card>
      </Flex>

      <Row
        gutter={screens.xs ? 8 : 16}
        justify="center"
        style={{
          backgroundColor: "#F9FAFB",
          // backgroundColor: "red",
          marginBottom: -100,
          marginLeft: "-8vw",
          marginRight: "-8vw",
          paddingTop: 60,
          paddingBottom: screens.xs ? 30 : 60,
          paddingLeft: screens.xs ? 30 : "8vw",
          paddingRight: screens.xs ? 30 : "8vw",
          textAlign: "center",
        }}
      >
        <Col span={24}>
          <h2
            style={{
              fontWeight: "600",
              color: "#002753",
              fontSize: 30,
              marginTop: 5,
              marginBottom: 10,
            }}
          >
            Our Core Values
          </h2>

          <p
            style={{
              color: "#374151",
              fontSize: screens.xs ? 16 : 20,
              lineHeight: 1.5,
              marginBottom: screens.xs ? 20 : 40,
            }}
          >
            The foundations of how we operate, innovate, and build trust with
            every customer and partner
          </p>
        </Col>

        {ITEMS.map(({ icon, title, desc }) => (
          <Col key={title} xs={24} sm={12} lg={8} xl={6}>
            <Card
              style={{
                backgroundColor: "#fff",
                border: "1px solid #eee",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: 20,
                width: "100%",
                minHeight: 280,
              }}
            >
              <Space direction="vertical" size={12} style={{ marginTop: 10 }}>
                <Avatar
                  size={70}
                  icon={icon}
                  style={{
                    background: "#FFD600" /* yellow circle */,
                  }}
                />

                <Title
                  level={4}
                  style={{
                    marginTop: 0,
                    marginBottom: 0,
                    fontWeight: 600,
                    color: "#002753",
                    fontSize: 24,
                  }}
                >
                  {title}
                </Title>

                <Paragraph
                  style={{
                    color: "#4B5563",
                    fontSize: 16,
                  }}
                >
                  {desc}
                </Paragraph>
              </Space>
            </Card>
          </Col>
        ))}
      </Row>
    </Space>
  );
};

export default AboutUs;
